import { Button, useToast } from '@gymcoach/ui';

import { useGymLogoUrl } from '@/shell/useGymLogoUrl';

import { AuthFrame } from './AuthFrame';
import { useAuth } from './AuthProvider';
import { authCopy } from './copy';
import { NewPasswordForm } from './NewPasswordForm';
import { useMe } from './useMe';

const c = authCopy.forced;

/**
 * First sign-in with a temporary password (DESIGN.md A2). RequireAuth shows this in place
 * of every screen until profiles.must_change_password is cleared, which only the
 * database does, once the password really changed (complete_password_change).
 * Then the screen the person asked for appears, with no extra navigation.
 */
export function ForcedPasswordChange() {
  const { profile, gym } = useMe();
  const { signOut } = useAuth();
  const { toast } = useToast();
  const logoUrl = useGymLogoUrl(gym.logo_path);
  const firstName = profile.full_name.trim().split(/\s+/)[0] ?? profile.full_name;

  return (
    <AuthFrame
      gymName={gym.name}
      logoUrl={logoUrl}
      footer={
        <Button variant="ghost" size="sm" onClick={() => void signOut()}>
          {c.signOut}
        </Button>
      }
    >
      <h1 className="text-2xl font-bold tracking-tight text-ink">{c.title(firstName)}</h1>
      <p className="mt-1.5 text-base text-ink-muted">{c.subtitle(gym.name)}</p>
      <div className="mt-5">
        <NewPasswordForm
          email={profile.email}
          onDone={() => toast({ title: c.done(gym.name), tone: 'success' })}
        />
      </div>
      <p className="mt-4 text-sm text-ink-muted">{c.reassure}</p>
    </AuthFrame>
  );
}
